import React from 'react';
// import Select from 'react-select';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// import { bindActionCreators } from 'redux';
import { bindActionCreators } from 'redux';
import { dataThunks, carSetThunks } from 'shared/actions/searchForm';

import { injectIntl, intlShape } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import currencies from 'shared/constants/json/currency.json';

// import * as formActions from 'shared/actions/searchForm';

import { Select, NumberInputWithSelect } from 'shared/components/UI';
import { MoneyIcon } from 'shared/components/Icons';

import { injectTopMakesToOptions } from 'shared/components/SearchPanel/transformOptions';

import s from './LeasingHeadForm.css';

const isMobile = __APP__ === 'mobile';
const sluggifiedCurrency = currencies.map(item => ({ ...item, id: item.slug }));
class LeasingHeadForm extends React.Component {
  static propTypes = {
    currency: PropTypes.shape().isRequired,
    isNew: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number]),
    prepaid: PropTypes.shape(),
    makes: PropTypes.arrayOf(PropTypes.shape()),
    brandToChose: PropTypes.shape(),
    // formState: PropTypes.shape().isRequired,
    // formVocabulary: PropTypes.shape().isRequired,
    // formData: PropTypes.shape().isRequired,
    selectedActions: PropTypes.shape({
      set: PropTypes.shape(),
    }).isRequired, // functions
    //
    intl: intlShape.isRequired,
  };

  static defaultProps = {
    brandToChose: null,
    isNew: null,
    makes: [],
    prepaid: null,
  };

  state = {
    selectedCurrency: null,
  };

  // componentDidMount() {
  //   const { formState: { make, prepaid }, selectedActions: { set } } = this.props;
  //   if (make && !prepaid) {
  //     set.brandToChose(make);
  //   }
  // }

  // onBrandChange(brand) {
  //   const selectedSetActions = this.props.selectedActions.set;
  //   selectedSetActions.brandToChose(brand);
  //   selectedSetActions.make(brand);
  // }

  render() {
    const {
      intl,
      makes,
      selectedActions: actons,
      brandToChose,
      prepaid,
      isNew,
      currency,
    } = this.props;

    const makesWithTop = injectTopMakesToOptions(makes, intl);

    const prepaidSumDisabled = isNew || !!(brandToChose && brandToChose.id);
    const makeDisabled = !!prepaid;

    const titleKey =
      brandToChose && brandToChose.id === -1 && intl.formatMessage({ id: 'locale' }) === 'uk'
        ? 'title_uk'
        : 'title';

    const rootClas = isMobile ? s.rootMobile : s.root;
    return (
      <div className={rootClas}>
        <div className={s.brand}>
          <Select
            disabled={makeDisabled}
            placeholder={intl.formatMessage({ id: 'Марка' })}
            instanceId="make-ff"
            name="brandToChose"
            options={makesWithTop}
            labelKey={titleKey}
            valueKey="id"
            onChange={actons.set.brandToChose}
            value={brandToChose}
            matchPos="start"
          />
        </div>
        <div className={s.or}>
          {intl.formatMessage({ id: 'или' })}
        </div>
        <div className={s.prepaid}>
          <NumberInputWithSelect
            className={s.prepaidSum}
            disabled={prepaidSumDisabled}
            placeholder={intl.formatMessage({ id: 'Удобной сумме аванса' })}
            name="prepaid"
            Icon={MoneyIcon}
            value={prepaid}
            onChange={actons.set.prepaid}
            unitsSwitchOptions={sluggifiedCurrency}
            unitsSwitchValue={currency || sluggifiedCurrency[0]}
            onUnitsChange={actons.set.currency}
            titleKey="symbol"
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isNew: state.searchForm.selected.isNew,
  make: state.searchForm.selected.make,
  currency: state.searchForm.selected.currency,
  prepaid: state.searchForm.selected.prepaid,
  makes: state.searchForm.vocabulary.makes,
  brandToChose: state.searchForm.data.brandToChose,
});

const mapDispatchToProps = dispatch => ({
  selectedActions: {
    set: bindActionCreators(
      {
        ...carSetThunks,
        ...dataThunks,
      },
      dispatch,
    ),
  },
});

export default withStyles(s)(
  connect(mapStateToProps, mapDispatchToProps)(injectIntl(LeasingHeadForm)),
);



// WEBPACK FOOTER //
// ./src/desktop/components/SearchPanelV2/LeasingHeadForm/LeasingHeadForm.js